import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Form, Alert, Spinner, Table, Nav,Modal } from "react-bootstrap";
import BackgroundFooter from "./BackgroundFooter";
import "../ComponentsCss/Homepage.css";
import axios from "axios";
import "../ComponentsCss/SecurityModel.css";
import { useAuth } from "../contexts/AuthContext";
import { ReactMultiEmail, isEmail } from 'react-multi-email';
import 'react-multi-email/dist/style.css';
import { logActivity } from '../utils/activityLogApi';

 
const Sponsor = ({ userData }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false
  );
  const [orgName, setOrgName] = useState("");
 const [orgEmails, setOrgEmails] = useState([]);  // Changed from orgEmail to orgEmails (array)
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [invitedUsers, setInvitedUsers] = useState([]);
  const [loadingInvites, setLoadingInvites] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [checkingEmail, setCheckingEmail] = useState(false);
 
  // Admin view state
  const [activeTab, setActiveTab] = useState("myInvites");
  const [orgInvites, setOrgInvites] = useState([]);
  const [loadingOrgInvites, setLoadingOrgInvites] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isProfileLoading, setIsProfileLoading] = useState(true);
  const getUserRegion = () => sessionStorage.getItem("userRegion") || "GB";
  const invitedByUserId = userData?.["cognito:username"];
 
  const extractDomain = (email) => {
    if (!email || !email.includes("@")) return null;
    return email.split("@")[1].toLowerCase();
  };
 
  const { profile } = useAuth();
  const orgId = profile?.orgId;

const validateEmailDomain = (inviterEmail, inviteeEmail) => {
  const inviterDomain = extractDomain(inviterEmail);
  const inviteeDomain = extractDomain(inviteeEmail);

  if (!inviterDomain || !inviteeDomain) {
    return false; // if any email is invalid, treat as not valid
  }

  return inviterDomain !== inviteeDomain; // valid only if external domain
};

 
  // Check if user is admin
  useEffect(() => {
    if (userData) {
      const groups = userData["cognito:groups"] || [];
      const hasAdminRole = groups.some(
        (group) => group.toLowerCase() === "admin" || group.toLowerCase() === "admins"
      );
      setIsAdmin(hasAdminRole);
    }
  }, [userData]);

  // Add this useEffect to wait for profile/orgId to load
useEffect(() => {
  if (profile && orgId) {
    setIsProfileLoading(false);
  }
}, [profile, orgId]);

 
  // Check if email is already invited globally
  const checkGlobalInvitation = async (email) => {
    try {
      const response = await axios.get(
        "https://nkclhd58nj.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/check-invitation",
        {
          params: { email },
          headers: { Region: getUserRegion() },
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error checking global invitation:", error);
      return { exists: false };
    }
  };
 
  const fetchInvitedUsers = async () => {
    if (!invitedByUserId) return;
    setLoadingInvites(true);
    try {
      const res = await axios.get(
        "https://y6li6f5rmd.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/invited-users",
        {
          params: { invitedByUserId },
          headers: { Region: getUserRegion() },
        }
      );
      setInvitedUsers(res.data);
    } catch (error) {
      console.error("❌ Error fetching invited users:", error);
      setErrorMsg("Failed to load invited users.");
    } finally {
      setLoadingInvites(false);
    }
  };
 
  // Fetch organization-wide invites for admin
  const fetchOrganizationInvites = async () => {
    if (!userData?.email) return;
 
    setLoadingOrgInvites(true);
    try {
      const res = await axios.get(
        "https://kii9x9t4t5.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/admin/organization-invites",
        {
          params: { userEmail: userData.email },
          headers: { Region: getUserRegion() },
        }
      );
      setOrgInvites(res.data);
    } catch (error) {
      console.error("❌ Error fetching organization invites:", error);
      setErrorMsg("Failed to load organization invites.");
    } finally {
      setLoadingOrgInvites(false);
    }
  };
 
  // Load org invites when admin switches to that tab
  useEffect(() => {
    if (isAdmin && activeTab === "orgInvites") {
      fetchOrganizationInvites();
    }
  }, [activeTab, isAdmin]);
 
  const handleRefresh = async () => {
    setRefreshing(true);
    setSuccessMsg("");
    setErrorMsg("");
 
    try {
      if (activeTab === "myInvites") {
        await fetchInvitedUsers();
      } else if (activeTab === "orgInvites") {
        await fetchOrganizationInvites();
      }
      setSuccessMsg("✅ Data refreshed successfully!");
    } catch (error) {
      setErrorMsg("Failed to refresh data.");
    } finally {
      setRefreshing(false);
    }
  };
 
 
 
 
 
 
  // 1) helper that actually sends the invite with finalModules
// const sendInviteWithModules = async () => {
//   setLoading(true);
//   setCheckingEmail(true);
//   setSuccessMsg("");
//   setErrorMsg("");

//   try {
//     const inviterEmail = userData?.email;
//     const inviterName = userData?.name || userData?.given_name || "";

//     if (!inviterEmail) {
//       setErrorMsg("Unable to determine your email address. Please try again.");
//       return;
//     }

//     // Critical validation - ensure orgId is loaded
//     if (!orgId) {
//       setErrorMsg("⚠️ Organization ID not loaded. Please wait or refresh the page.");
//       setIsProfileLoading(true); // Reset loading state
//       return;
//     }
//   const isDomainValid = validateEmailDomain(inviterEmail, orgEmail);
   
//     if (!isDomainValid) {
//       setErrorMsg(
//         `You cannot invite another user from your own organization domain (@${extractDomain(inviterEmail)}).`
//       );
//       return;
//     }
//     // 3. Check if user is already invited anywhere globally
// const globalCheck = await checkGlobalInvitation(orgEmail);

// if (globalCheck.exists) {
//   setErrorMsg(`This email is already invited by another organization or user.`);
//   return;
// }


//     await axios.post(
//   "https://e0nxidwzg0.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/invite",
//   {
//     email: orgEmail,
//     organization: orgName,
//     invitedByUserId,
//     modules: finalModules
//   },
//   {
//     params: {
//       inviterEmail,
//       inviterName,
//       organizationId: orgId   // add this here
//     },
//     headers: { Region: getUserRegion() }
//   }
// );


//     setSuccessMsg("✅ Invitation sent successfully!");
//     setOrgName("");
//     setOrgEmail("");
//     setFinalModules([]);
//     fetchInvitedUsers();
//   } catch (error) {
//     console.error("Error inviting user:", error);
//     setErrorMsg(error.response?.data?.message || "An error occurred.");
//   } finally {
//     setLoading(false);
//     setCheckingEmail(false);
//   }
// };

 // Replace the entire sendInviteWithModules function
const sendBulkInvites = async () => {
  setLoading(true);
  setCheckingEmail(true);
  setSuccessMsg("");
  setErrorMsg("");

  try {
    const inviterEmail = userData?.email;
    const inviterName = userData?.name || userData?.given_name || "";

    if (!inviterEmail) {
      setErrorMsg("Unable to determine your email address. Please try again.");
      return;
    }

    if (!orgId) {
      setErrorMsg("⚠️ Organization ID not loaded. Please wait or refresh the page.");
      setIsProfileLoading(true);
      return;
    }

    if (orgEmails.length === 0) {
      setErrorMsg("❌ Please add at least one email address.");
      return;
    }

    // Validate all emails
    const invalidEmails = [];
    const alreadyInvitedEmails = [];
    const sameDomainEmails = [];

    // Check each email
    for (const email of orgEmails) {
      // Validate email format
      if (!isEmail(email)) {
        invalidEmails.push(email);
        continue;
      }

      // Check domain validation
      if (!validateEmailDomain(inviterEmail, email)) {
        sameDomainEmails.push(email);
        continue;
      }

      // Check if already invited
      const globalCheck = await checkGlobalInvitation(email);
      if (globalCheck.exists) {
        alreadyInvitedEmails.push(email);
      }
    }

    // Filter out invalid emails
    const validEmails = orgEmails.filter(
      email =>
        !invalidEmails.includes(email) &&
        !sameDomainEmails.includes(email) &&
        !alreadyInvitedEmails.includes(email)
    );

    if (validEmails.length === 0) {
      let errorMessage = "❌ No valid emails to invite.\n";
      if (invalidEmails.length > 0) {
        errorMessage += `\n• Invalid format: ${invalidEmails.join(", ")}`;
      }
      if (sameDomainEmails.length > 0) {
        errorMessage += `\n• Same domain (not allowed): ${sameDomainEmails.join(", ")}`;
      }
      if (alreadyInvitedEmails.length > 0) {
        errorMessage += `\n• Already invited: ${alreadyInvitedEmails.join(", ")}`;
      }
      setErrorMsg(errorMessage);
      return;
    }

    // ✅ Send ONE bulk request with ALL valid emails
    const response = await axios.post(
      "https://e0nxidwzg0.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/invite",
      {
        emails: validEmails,  // Array of all valid emails
        organization: orgName,
        invitedByUserId,
        modules: finalModules
      },
      {
        params: {
          inviterEmail,
          inviterName,
          organizationId: orgId
        },
        headers: { Region: getUserRegion() }
      }
    );

    // Handle backend response
    const { successCount, failedCount, alreadyInvitedCount } = response.data;

    // Build success message
    let successMessage = `✅ Successfully sent ${successCount || validEmails.length} invitation(s)!`;

    if (invalidEmails.length > 0 || sameDomainEmails.length > 0 || 
        alreadyInvitedEmails.length > 0 || (failedCount && failedCount > 0)) {
      successMessage += "\n\n⚠️ Some emails were skipped:";
      if (invalidEmails.length > 0) {
        successMessage += `\n• Invalid format: ${invalidEmails.join(", ")}`;
      }
      if (sameDomainEmails.length > 0) {
        successMessage += `\n• Same domain: ${sameDomainEmails.join(", ")}`;
      }
      if (alreadyInvitedEmails.length > 0) {
        successMessage += `\n• Already invited: ${alreadyInvitedEmails.join(", ")}`;
      }
      if (failedCount && failedCount > 0) {
        successMessage += `\n• Failed to send: ${failedCount} email(s)`;
      }
    }

    setSuccessMsg(successMessage);
    setOrgName("");
    setOrgEmails([]);
    setSelectedTemplateId("");
    setFinalModules([]);
    fetchInvitedUsers();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Third-Party',
  category:    'Invitation',
  action:      'Bulk Invite Sent',
  severity:    'success',
  description: `Sent ${validEmails.length} external invite(s) to ${orgName}`,});

  } catch (error) {
    console.error("Error inviting users:", error);
    setErrorMsg(error.response?.data?.message || "An error occurred while sending invitations.");
  } finally {
    setLoading(false);
    setCheckingEmail(false);
  }
};


// 2) form submit only decides WHEN to call it
const handleSubmit = (e) => {
  e.preventDefault();
  // if you show review modal first, open it here; otherwise send directly:
   sendBulkInvites();
  // sendInviteWithModules();
};
 
 
 
 
 
  const handleDelete = async (email) => {
    if (!window.confirm(`Are you sure you want to delete ${email}?`)) return;
    try {
      await axios.delete(
        "https://tjgc1d9esl.execute-api.ap-southeast-2.amazonaws.com/prod/api/external/invited-user",
        {
          data: { email, invitedByUserId },
          headers: { Region: getUserRegion() },
        }
      );
      setSuccessMsg(`Deleted ${email} successfully!`);
      fetchInvitedUsers();
      await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Third-Party',
  category:    'Invitation',
  action:      'Invite Deleted',
  severity:    'warning',
  description: `External invite deleted for ${email}`,});
    } catch (error) {
      console.error("Error deleting user:", error);
      setErrorMsg(`Failed to delete ${email}.`);
    }
  };
 
  useEffect(() => {
    if (invitedByUserId) fetchInvitedUsers();
    else setErrorMsg("User ID not available. Please try again.");
  }, [invitedByUserId]);
 
  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccessMsg("");
      setErrorMsg("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [successMsg, errorMsg]);
 
 
 const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [showTemplateManageModal, setShowTemplateManageModal] = useState(false);
  const [showCreateTemplateModal, setShowCreateTemplateModal] = useState(false);
  const [showEditTemplateModal, setShowEditTemplateModal] = useState(false);
  const [templateName, setTemplateName] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [editingTemplate, setEditingTemplate] = useState(null);
 
const [showTemplateModal, setShowTemplateModal] = useState(false);
const [showReviewModal, setShowReviewModal] = useState(false);
 
const [tempSelection, setTempSelection] = useState([]);
const [finalModules, setFinalModules] = useState([]);
 const [moduleSearch, setModuleSearch] = useState("");
 
const allModules = [
  "Begin Now",
  "Unified Control Mapping",
  "Asset Inventory Management",
  "India DPDP Act ",
  "CCPA ",
  "GDPR ",
  "UAE Data Protection Module ",
  "UAE PDPL" ,
  "Data Governance and Risk Management ",
  "Legal and Regulatory Compliance ",
  "Privacy by Design and Engineering",
  "Privacy Program Framework ",
  "NIST Privacy Framework ",
  "NIST SP 800-161 ",
  "NCSC Supply Chain Guidelines ",
  "Cert-IN ",
  "NIS2 ",
  "EU - DORA",
"EU - CRA (Cyber Resilience Act)",
"EU - NIS2 Directive",
"EU - EU AI Act",
  "India - CSCRF by SEBI",
"India - CSCRF Checklist",
  "Ireland - National Cyber Security Bill",
  "UK - Cyber Security and Resilience Bill",
"UK - GovAssure Program",
"UK - Incident Reporting",
"UK - Third-Party Infrastructure",
"UK - Regulatory Engagement",
"UK - Encryption & ICO Readiness",
"UK - Quantum-Resilient Security",
"UK - PECR Compliance",
"UK - Telecom Security Act",
"UK - NCSC CAF",
"UK - PSN",
"UK - PS21/3",
"UK - Cyber Essential",
"USA  CIRCIA",
"USA - Upcoming AI Executive Orders",
"USA - HIPAA",
"USA - SOX Compliance",
"ISO27001 - Organizational",
"ISO27001 - People",
"ISO27001 - Physical",
"ISO27001 - Technological",
 "SOC2",
  "NIST SP 800-53",
  "NIST SP 800-63 IAM",
  "PCI-DSS",
  "OTIOT Security",
  "RED",
  "Generative AI Risk",
  "Application / Database Security",
  "DevSecOps",
  "Private Cloud / Hypervisor",
  "Blockchain Security",
  "Wireless Security",
"Network Security",
"Cisco",
"Juniper",
"Fortinet",
"Palo Alto",
"Checkpoint",
"AWS Cloud",
"Azure/Entra Cloud",
"Google Cloud",
"M365",
"Integrations"
];
 
const openTemplate = () => {
  setTempSelection(finalModules);          // preload previous
  setShowTemplateModal(true);
 
};
 
const handleTemplateChange = (value, checked) => {
  setTempSelection(prev =>
    checked ? [...prev, value] : prev.filter(m => m !== value)
  );
};
 
const goToReview = () => {
  setFinalModules(tempSelection);
  setShowTemplateModal(false);
  setShowReviewModal(true);
};
 
const confirmAndSend = () => {
  setFinalModules(tempSelection);  // Save modules
  setShowReviewModal(false);
  setSuccessMsg("Template saved successfully! You can now send the invite.");
};
 
 // Replace the entire fetchTemplates function
const fetchTemplates = async () => {
  if (!invitedByUserId) return;
  setLoadingTemplates(true);
  try {
    const res = await axios.get(
      `https://fztdq6cssi.execute-api.ap-southeast-2.amazonaws.com/prod/api/invitation-templates/user/${invitedByUserId}`,
      {
        headers: { Region: getUserRegion() },
      }
    );
    setTemplates(res.data);
  } catch (error) {
    console.error("Error fetching templates:", error);
    setErrorMsg("Failed to load templates.");
  } finally {
    setLoadingTemplates(false);
  }
};

// Replace the entire saveTemplate function
const saveTemplate = async () => {
  if (!templateName.trim()) {
    setErrorMsg("Please provide a template name.");
    return;
  }
  if (tempSelection.length === 0) {
    setErrorMsg("Please select at least one module.");
    return;
  }

  setLoading(true);
  try {
    await axios.post(
      "https://wre90mhaci.execute-api.ap-southeast-2.amazonaws.com/prod/api/invitation-templates/create",
      {
        userId: invitedByUserId,
        templateName: templateName.trim(),
        modules: tempSelection,
      },
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${templateName}" saved successfully!`);
    setTemplateName("");
    setTempSelection([]);
    setShowCreateTemplateModal(false);
    fetchTemplates();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Third-Party',
  category:    'Invitation',
  action:      'Template Created',
  severity:    'info',
  description: `Invitation template "${templateName}" created with ${tempSelection.length} modules`,});
  } catch (error) {
    console.error("Error saving template:", error);
    setErrorMsg(error.response?.data?.message || "Failed to save template.");
  } finally {
    setLoading(false);
  }
};

// Replace the entire updateTemplate function
const updateTemplate = async () => {
  if (!templateName.trim()) {
    setErrorMsg("Please provide a template name.");
    return;
  }
  if (tempSelection.length === 0) {
    setErrorMsg("Please select at least one module.");
    return;
  }

  setLoading(true);
  try {
    await axios.put(
      `https://svmwhurwad.execute-api.ap-southeast-2.amazonaws.com/prod/api/invitation-templates/${editingTemplate.templateId}/update`,
      {
        userId: invitedByUserId,
        templateName: templateName.trim(),
        modules: tempSelection,
      },
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${templateName}" updated successfully!`);
    setTemplateName("");
    setTempSelection([]);
    setEditingTemplate(null);
    setShowEditTemplateModal(false);
    fetchTemplates();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Third-Party',
  category:    'Invitation',
  action:      'Template Updated',
  severity:    'info',
  description: `Invitation template "${templateName}" updated`,});
  } catch (error) {
    console.error("Error updating template:", error);
    setErrorMsg(error.response?.data?.message || "Failed to update template.");
  } finally {
    setLoading(false);
  }
};

// Replace the entire deleteTemplate function
const deleteTemplate = async (templateId, name) => {
  if (!window.confirm(`Are you sure you want to delete template "${name}"?`)) return;
  
  try {
    await axios.delete(
      `https://xla033ncpi.execute-api.ap-southeast-2.amazonaws.com/prod/api/invitation-templates/${templateId}/user/${invitedByUserId}`,
      {
        headers: { Region: getUserRegion() },
      }
    );
    setSuccessMsg(`✅ Template "${name}" deleted successfully!`);
    fetchTemplates();
    await logActivity({
  userData,
  orgId,
  region: getUserRegion(),
  module:      'Third-Party',
  category:    'Invitation',
  action:      'Template Deleted',
  severity:    'warning',
  description: `Invitation template "${name}" deleted`,});
  } catch (error) {
    console.error("Error deleting template:", error);
    setErrorMsg(`Failed to delete template "${name}".`);
  }
};


  // Load templates on component mount
  useEffect(() => {
    if (invitedByUserId) {
      fetchInvitedUsers();
      fetchTemplates();
    }
  }, [invitedByUserId]);
 
 
  return (
    <>
      <Row className="g-0">
        <Col xs={12} md={isSidebarCollapsed ? 11 : 10} className="p-4">
          {/* Invite Form */}
          <Card className="mb-4 internalInvite">
            <Card.Body>
              <h5>Invite Third-Party Organization</h5>
 
             <Form onSubmit={handleSubmit}>
  <div className="form-row">
    <Form.Group controlId="orgName" className="mb-3 form-group">
      <Form.Label>Organization Name</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g. DHL, UPS"
        value={orgName}
        onChange={(e) => setOrgName(e.target.value)}
        required
      />
    </Form.Group>

   <Form.Group controlId="orgEmails" className="mb-3 form-group">
  <Form.Label>Contact Emails (Multiple)</Form.Label>
  <ReactMultiEmail
    placeholder="Enter email addresses (press Space, Enter, Comma, or Semicolon to separate)"
    emails={orgEmails}
    onChange={(_emails) => {
      setOrgEmails(_emails);
    }}
    validateEmail={email => {
      return isEmail(email); // Validate email format
    }}
    getLabel={(email, index, removeEmail) => {
      return (
        <div data-tag key={index}>
          <div data-tag-item>{email}</div>
          <span data-tag-handle onClick={() => removeEmail(index)}>
            ×
          </span>
        </div>
      );
    }}
    style={{
      minHeight: '50px',
      border: '1px solid #ced4da',
      borderRadius: '0.25rem',
      padding: '0.375rem 0.75rem'
    }}
  />
  {userData?.email && (
    <Form.Text className="text-muted">
      🌐 Only external organizations allowed. Cannot invite users from your
      domain: @{extractDomain(userData.email)}
      <br />
      💡 Tip: Press Space, Enter, Comma, or Semicolon to add multiple emails
    </Form.Text>
  )}
  {orgEmails.length > 0 && (
    <div style={{ marginTop: '8px', fontSize: '13px', color: '#28a745' }}>
      ✓ {orgEmails.length} email(s) added
    </div>
  )}
</Form.Group>

  </div>

  {/* Template Selector */}
  <Form.Group controlId="templateSelect" className="mb-3">
    <Form.Label>Select Template (Optional)</Form.Label>
    <Form.Select
      value={selectedTemplateId}
      onChange={(e) => {
        const templateId = e.target.value;
        setSelectedTemplateId(templateId);
        if (templateId) {
          const template = templates.find(t => t.templateId === templateId);
          if (template) {
            setFinalModules(template.modules);
          }
        } else {
          setFinalModules([]);
        }
      }}
    >
      <option value="">-- No Template --</option>
      {templates.map((template) => (
        <option key={template.templateId} value={template.templateId}>
          {template.templateName} ({template.modules.length} modules)
        </option>
      ))}
    </Form.Select>
    <Form.Text className="text-muted">
      Select a saved template or create a new one.
    </Form.Text>
  </Form.Group>

  {finalModules.length > 0 && (
    <Alert variant="info" className="mb-3">
      <strong>Selected Template Modules:</strong> {finalModules.join(", ")}
    </Alert>
  )}

  <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
  <Button 
  variant="primary" 
  type="submit" 
  disabled={loading || checkingEmail || isProfileLoading || !orgId || orgEmails.length === 0}
>
  {isProfileLoading ? (
    <>
      <Spinner size="sm" animation="border" className="me-1" />
      Loading Profile...
    </>
  ) : checkingEmail ? (
    <>
      <Spinner size="sm" animation="border" className="me-1" />
      Validating Emails...
    </>
  ) : loading ? (
    <>
      <Spinner size="sm" animation="border" className="me-1" />
      Sending {orgEmails.length} Invite(s)...
    </>
  ) : (
    `Send ${orgEmails.length > 0 ? orgEmails.length : ''} Invite${orgEmails.length !== 1 ? 's' : ''}`
  )}
</Button>



    <Button
      variant="outline-secondary"
      type="button"
      onClick={() => setShowTemplateManageModal(true)}
    >
      📋 Manage Templates
    </Button>
  </div>

 
{finalModules.length > 0 && (
  <div style={{ marginTop: "8px", fontSize: "13px", color: "#555" }}>
    Template modules: {finalModules.join(", ")}
  </div>
)}
 
{/* <Modal
  show={showTemplateModal}
  onHide={() => setShowTemplateModal(false)}
  centered
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Select modules for invitee</Modal.Title>
  </Modal.Header>
 
  <Modal.Body className="invite-modal-body">
    <p className="invite-modal-subtitle">
      Choose which modules this user must complete. You can review them in the next step.
    </p>
 
    <div className="invite-modules-grid">
      {allModules.map(m => (
        <label
          key={m}
          className={
            "invite-module-card" +
            (tempSelection.includes(m) ? " invite-module-card-selected" : "")
          }
        >
          <input
            type="checkbox"
            checked={tempSelection.includes(m)}
            onChange={e => handleTemplateChange(m, e.target.checked)}
          />
          <span className="invite-module-label">{m}</span>
        </label>
      ))}
    </div>
  </Modal.Body>
 
  <Modal.Footer className="invite-modal-footer">
    <Button variant="secondary" onClick={() => setShowTemplateModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={goToReview}
      disabled={tempSelection.length === 0}
    >
      Review Template
    </Button>
  </Modal.Footer>
</Modal>
 
<Modal
  show={showReviewModal}
  onHide={() => setShowReviewModal(false)}
  centered
  dialogClassName="invite-review-dialog"
>
  <Modal.Header closeButton className="invite-review-header">
    <Modal.Title>Confirm invitation template</Modal.Title>
  </Modal.Header>
 
  <Modal.Body className="invite-review-body">
    <div className="invite-review-box">
      <h6 className="invite-review-title">Modules to complete</h6>
 
      <ul className="invite-review-list">
        {finalModules.map(m => (
          <li key={m}>{m}</li>
        ))}
      </ul>
    </div>
 
    <p className="invite-review-note">
      These modules will be included in the invitation email so the user knows
      exactly what to complete.
    </p>
  </Modal.Body>
 
  <Modal.Footer className="invite-review-footer">
    <Button
  variant="outline-secondary"
  onClick={() => {
    setShowReviewModal(false);
    setShowTemplateModal(true); // go back to first modal
  }}
>
  Back
</Button>
 
 
 
    <Button variant="primary" onClick={confirmAndSend} disabled={loading}>
      Save
    </Button>
  </Modal.Footer>
</Modal> */}
 

 {/* Template Management Modal */}
<Modal
  show={showTemplateManageModal}
  onHide={() => setShowTemplateManageModal(false)}
  size="lg"
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>📋 Manage Invitation Templates</Modal.Title>
  </Modal.Header>
  
  <Modal.Body>
    <div className="d-flex justify-content-between align-items-center mb-3">
      <p className="mb-0">Create, edit, or delete invitation templates</p>
      <Button
        variant="primary"
        size="sm"
        onClick={() => {
          setTemplateName("");
          setTempSelection([]);
          setShowTemplateManageModal(false);
          setShowCreateTemplateModal(true);
        }}
      >
        + Create New Template
      </Button>
    </div>

    {loadingTemplates ? (
      <div className="text-center py-4">
        <Spinner animation="border" variant="primary" />
        <p className="mt-2">Loading templates...</p>
      </div>
    ) : templates.length > 0 ? (
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Template Name</th>
            <th>Modules</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {templates.map((template) => (
            <tr key={template.templateId}>
              <td><strong>{template.templateName}</strong></td>
              <td>
                <small>{template.modules.length} modules</small>
              </td>
              <td>
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="me-2"
                  onClick={() => {
                    setEditingTemplate(template);
                    setTemplateName(template.templateName);
                    setTempSelection(template.modules);
                     setShowTemplateManageModal(false);
                    setShowEditTemplateModal(true);
                  }}
                >
                  ✏️ Edit
                </Button>
                <Button
                  variant="outline-danger"
                  size="sm"
                  onClick={() => deleteTemplate(template.templateId, template.templateName)}
                >
                  🗑️ Delete
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    ) : (
      <Alert variant="info">
        No templates created yet. Click "Create New Template" to get started.
      </Alert>
    )}
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={() => setShowTemplateManageModal(false)}>
      Close
    </Button>
  </Modal.Footer>
</Modal>
{/* Create Template Modal */}
<Modal
  show={showCreateTemplateModal}
  onHide={() => setShowCreateTemplateModal(false)}
  centered
  size="lg"
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Create New Template</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-modal-body">
    <Form.Group className="mb-3">
      <Form.Label>Template Name *</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g., Standard Compliance, Security Audit, GDPR Package"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        required
      />
    </Form.Group>

     <p className="invite-modal-subtitle d-flex justify-content-between align-items-center">
  Select modules to include in this template:
 
  <Form.Control
    type="text"
    placeholder="Search modules..."
    value={moduleSearch}
    onChange={(e) => setModuleSearch(e.target.value)}
    style={{ width: "220px", marginRight: "44%" }}
  />
</p>
 
{/* Filter modules based on search */}
<div className="invite-modules-grid">
  {allModules
    .filter((m) =>
      m.toLowerCase().includes(moduleSearch.toLowerCase())
    )
    .map((m) => (
      <label
        key={m}
        className={
          "invite-module-card" +
          (tempSelection.includes(m)
            ? " invite-module-card-selected"
            : "")
        }
      >
        <input
          type="checkbox"
          checked={tempSelection.includes(m)}
          onChange={(e) =>
            handleTemplateChange(m, e.target.checked)
          }
        />
        <span className="invite-module-label">{m}</span>
      </label>
    ))}
</div>
  </Modal.Body>

  <Modal.Footer className="invite-modal-footer">
    <Button variant="secondary"onClick={() => setShowCreateTemplateModal(false)}>
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={saveTemplate}
      disabled={loading || !templateName.trim() || tempSelection.length === 0}
    >
      {loading ? (
        <>
          <Spinner size="sm" animation="border" className="me-1" />
           Creating...
        </>
      ) : (
       "💾 Create Template"
      )}
    </Button>
  </Modal.Footer>
</Modal>

 {/* Edit Template Modal */}
<Modal
  show={showEditTemplateModal}
  onHide={() => {
    setShowEditTemplateModal(false);
    setEditingTemplate(null);
    setTemplateName("");
    setTempSelection([]);
  }}
  centered
  size="lg"
  dialogClassName="invite-modal-dialog"
>
  <Modal.Header closeButton className="invite-modal-header">
    <Modal.Title>Edit Template</Modal.Title>
  </Modal.Header>

  <Modal.Body className="invite-modal-body">
    <Form.Group className="mb-3">
      <Form.Label>Template Name *</Form.Label>
      <Form.Control
        type="text"
        placeholder="e.g., Standard Compliance, Security Audit, GDPR Package"
        value={templateName}
        onChange={(e) => setTemplateName(e.target.value)}
        required
      />
    </Form.Group>

    <p className="invite-modal-subtitle d-flex justify-content-between align-items-center">
      Select modules to include in this template:
      
      <Form.Control
        type="text"
        placeholder="Search modules..."
        value={moduleSearch}
        onChange={(e) => setModuleSearch(e.target.value)}
        style={{ width: "220px", marginRight: "44%" }}
      />
    </p>

    {/* Filter modules based on search */}
    <div className="invite-modules-grid">
      {allModules
        .filter((m) =>
          m.toLowerCase().includes(moduleSearch.toLowerCase())
        )
        .map((m) => (
          <label
            key={m}
            className={
              "invite-module-card" +
              (tempSelection.includes(m)
                ? " invite-module-card-selected"
                : "")
            }
          >
            <input
              type="checkbox"
              checked={tempSelection.includes(m)}
              onChange={(e) =>
                handleTemplateChange(m, e.target.checked)
              }
            />
            <span className="invite-module-label">{m}</span>
          </label>
        ))}
    </div>
  </Modal.Body>

  <Modal.Footer className="invite-modal-footer">
    <Button 
      variant="secondary" 
      onClick={() => {
        setShowEditTemplateModal(false);
        setEditingTemplate(null);
        setTemplateName("");
        setTempSelection([]);
      }}
    >
      Cancel
    </Button>
    <Button
      variant="primary"
      onClick={updateTemplate}
      disabled={loading || !templateName.trim() || tempSelection.length === 0}
    >
      {loading ? (
        <>
          <Spinner size="sm" animation="border" className="me-1" />
          Updating...
        </>
      ) : (
        "💾 Update Template"
      )}
    </Button>
  </Modal.Footer>
</Modal>

 
                {successMsg && (
  <Alert variant="success" className="mt-3" style={{ whiteSpace: 'pre-line' }}>
    {successMsg}
  </Alert>
)}
{errorMsg && (
  <Alert variant="danger" className="mt-3" style={{ whiteSpace: 'pre-line' }}>
    {errorMsg}
  </Alert>
)}

              </Form>
            </Card.Body>
          </Card>
 
          {/* Professional Tab Navigation for Admin */}
          {isAdmin && (
            <div className="mb-3">
              <Nav variant="tabs" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                <Nav.Item>
                  <Nav.Link eventKey="myInvites" className="d-flex align-items-center">
                    <span className="me-2">📋</span> My Invites
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="orgInvites" className="d-flex align-items-center">
                    <span className="me-2">🏢</span> Organization Invites (Admin)
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
          )}
 
          {/* My Invites Tab Content */}
          {activeTab === "myInvites" && (
            <>
              {loadingInvites ? (
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" role="status" />
                  <p className="mt-2">Loading your invites...</p>
                </div>
              ) : invitedUsers.length > 0 ? (
                <Card className="InternalRefreshDiv">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">Invited Users</h5>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={handleRefresh}
                        disabled={refreshing}
                      >
                        {refreshing ? (
                          <>
                            <Spinner size="sm" animation="border" className="me-1" />
                            Refreshing...
                          </>
                        ) : (
                          <>🔄 Refresh</>
                        )}
                      </Button>
                    </div>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Organization</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {invitedUsers.map((user, idx) => (
                          <tr key={idx}>
                            <td>{user.email}</td>
                            <td>{user.organization}</td>
                            <td>
                              <span
                                className={`badge ${
                                  user.status === "Completed" ? "bg-success" : "bg-warning"
                                }`}
                              >
                                {user.status}
                              </span>
                            </td>
                            <td>
                              {user.status === "Completed" && (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  className="me-2"
                                  onClick={() => {
                                    const encodedEmail = btoa(user.email);
                                    window.location.href = `/view-dashboard/${encodedEmail}`;
                                  }}
                                >
                                  View Dashboard
                                </Button>
                              )}
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => handleDelete(user.email)}
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              ) : (
                <Card className="internalInvite">
                  <Card.Body className="text-center">
                    <p className="mb-3">No invited users yet.</p>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleRefresh}
                      disabled={refreshing}
                    >
                      {refreshing ? (
                        <>
                          <Spinner size="sm" animation="border" className="me-1" />
                          Refreshing...
                        </>
                      ) : (
                        <>🔄 Refresh</>
                      )}
                    </Button>
                  </Card.Body>
                </Card>
              )}
            </>
          )}
 
          {/* Organization Invites Tab Content (Admin Only) */}
          {activeTab === "orgInvites" && isAdmin && (
            <>
              {loadingOrgInvites ? (
                <div className="text-center my-4">
                  <Spinner animation="border" variant="primary" role="status" />
                  <p className="mt-2">Loading organization invites...</p>
                </div>
              ) : orgInvites.length > 0 ? (
                <Card className="InternalRefreshDiv">
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0">All Organization Invites</h5>
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={handleRefresh}
                        disabled={refreshing}
                      >
                        {refreshing ? (
                          <>
                            <Spinner size="sm" animation="border" className="me-1" />
                            Refreshing...
                          </>
                        ) : (
                          <>🔄 Refresh</>
                        )}
                      </Button>
                    </div>
                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          <th>Invited By</th>
                          <th>External User Email</th>
                          <th>External Organization</th>
                          <th>Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orgInvites.map((invite, idx) => (
                          <tr key={idx}>
                            <td>
                              <strong>{invite.inviterName || "N/A"}</strong>
                              <br />
                              <small className="text-muted">{invite.inviterEmail}</small>
                            </td>
                            <td>{invite.email}</td>
                            <td>{invite.organization}</td>
                            <td>
                              <span
                                className={`badge ${
                                  invite.status === "Completed" ? "bg-success" : "bg-warning"
                                }`}
                              >
                                {invite.status}
                              </span>
                            </td>
                            <td>
                              {invite.status === "Completed" && (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() => {
                                    const encodedEmail = btoa(invite.email);
                                    window.location.href = `/view-dashboard/${encodedEmail}`;
                                  }}
                                >
                                  View Dashboard
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              ) : (
                <Card className="internalInvite">
                  <Card.Body className="text-center">
                    <p className="mb-3">No organization invites found.</p>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={handleRefresh}
                      disabled={refreshing}
                    >
                      {refreshing ? (
                        <>
                          <Spinner size="sm" animation="border" className="me-1" />
                          Refreshing...
                        </>
                      ) : (
                        <>🔄 Refresh</>
                      )}
                    </Button>
                  </Card.Body>
                </Card>
              )}
            </>
          )}
        </Col>
      </Row>
      <BackgroundFooter />
    </>
  );
};
 
export default Sponsor;
 